import api from '../api'

export const createIaLog = (params) =>
  api.post('/v1/chat/ana', params)

export const updateIaLog =  (params, { messageId }) =>
  api.patch(`/v1/chat/ana/${ messageId }`, params)
